// ---------------- IMPORTY ----------------
import { useState } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'

// Contexts
import { AuthProvider } from './contexts/authProvider'

// UI
import Nav from './ui/Nav'
import Footer from './ui/Footer'
import { GlobalModalProvider } from './ui/Modal'

// PUBLIC PAGES
import Main from './public/pages/components/Main/MainDefault'
import GetInTouch from './public/pages/GetInTouch'
import Pricing from './public/pages/Offer'
import BlogPage from './public/pages/PortfolioBlog'
import BlogArticle from './public/pages/components/Blog/BlogArticle'
import Promo from './public/QrPage'


// ADMIN PAGES
import AdminPanelUserList from './private/admin/managers/UserManager'
import BlogAdmin from './private/admin/editors/BlogEditor'

// SYSTEM / MISC
import FormSuccess from './systemPages/Success'
import NotFound from './systemPages/404'
import Cookies from "./legalComponents/Cookies"
import PrivacyPolicy from './legalComponents/PrivacyPolicy'

// ---------------- ROUTING ----------------
function Routing() {
  const [cookiesConsent, setCookiesConsent] = useState(() => localStorage.getItem("cookiesConsent"))
  const location = useLocation()

  const resetCookiesConsent = () => {
    localStorage.removeItem("cookiesConsent")
    setCookiesConsent(null)
  }

  const handleExitComplete = () => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'instant' })
    }, 100)
  }

  const pathSegments = location.pathname.split('/')
  const isPanel = pathSegments.includes('panel')
  const isAdmin = pathSegments.includes('admin')

  return (
    <AuthProvider>
      <GlobalModalProvider>
        <Nav key={isPanel ? 'navpanel' : isAdmin ? 'navadmin' : 'nav'} panel={isPanel || isAdmin} admin={isAdmin} />

        <Cookies consent={cookiesConsent} setConsent={setCookiesConsent} />

        <AnimatePresence mode="wait" onExitComplete={handleExitComplete}>
          <Routes location={location} key={location.pathname}>

            {/* -------- PUBLIC -------- */}
            <Route path="/" element={<Main />} />
            <Route path="/:local" element={<Main />} />
            <Route path="/:local/kontakt" element={<GetInTouch />} />
            <Route path="/:local/wizytowka" element={<Promo />} />
            <Route path="/:local/oferta" element={<Pricing isRouter={false} />} />
            <Route path="/:local/blog" element={<BlogPage />} />
            <Route path="/:local/blog/:slug" element={<BlogArticle />} />
            {/* -------- ADMIN -------- */}
            <Route path='/admin/upload' element={<AdminPanelUserList />} />

            <Route path='/admin' element={<BlogAdmin />} />

            {/* -------- SYSTEM / MISC -------- */}
            <Route path="/sukces" element={<FormSuccess />} />
            <Route path="/:local/prywatnosc" element={<PrivacyPolicy />} />
            <Route path="*" element={<NotFound />} />

          </Routes>
        </AnimatePresence>

        <Footer key={isPanel ? 'footerpanel' : 'footer'} panel={isPanel || isAdmin} onResetCookies={resetCookiesConsent} />
      </GlobalModalProvider>
    </AuthProvider>
  )
}

export default Routing
